import React from 'react';
import '../styles/base.css';


function Footer() {
  return (
    <footer>
        <p>© Kevin Chung 2026 - chung.q.kevin@gmail.com | <a id = "footer-link" href="https://www.linkedin.com/in/kevin-chung-a34236123/">LinkedIn</a></p>
    </footer>
  );
}

export default Footer;
